import { render, staticRenderFns } from "./EditAlaModal.vue?vue&type=template&id=4349c4d6"
import script from "./EditAlaModal.vue?vue&type=script&lang=js"
export * from "./EditAlaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports